export default {"src":"/_next/static/media/oyster.bfa5357e.svg","height":16,"width":21,"blurWidth":0,"blurHeight":0};